export enum Provider {
	Permatel = 1,
	None = -1
}